import {Component} from '@angular/core';

@Component({
	selector: 'app-save-quote-changes-dialog',
	templateUrl: './save-quote-changes-dialog.component.html',
	styleUrls: ['./save-quote-changes-dialog.component.scss']
})
export class SaveQuoteChangesDialogComponent {}
